export default {
  nav: {
    main: 'Начало',
    ordersAndInvoices: 'Поръчки и фактури',
    drafts: 'Чернови',
    automation: 'Автоматизация',
    workspace: 'Работно пространство',
    templates: 'Шаблони',
    delivery: 'Доставка',
    settings: 'Настройки',
    shippingLabels: 'Етикети за доставка',
    subscriptions: 'Абонаменти',
    support: 'Поддръжка',
    developer: 'Разработчик',
    writeReview: 'Напишете отзив',
    supportTicket: 'Заявка за поддръжка',
    welcomeTour: 'Обиколка за добре дошли',
    administratorConsole: 'Администраторска конзола',
    logout: 'Изход',
  },
  dashboard: {
    pageTitle: 'Поръчки и фактури',
    pageDescription: 'Manage your orders and invoices',
    title: 'Поръчки и фактури',
    selectedOrders: '{count} избрани поръчки',
    completed: '% завършено',
    processing: 'Обработка, моля изчакайте...',
    bulkDownload: 'Масово изтегляне',
    upgradeBulkDownload: 'Надградете плана си за масово изтегляне',
    showFilters: 'Покажи филтри',
    hideFilters: 'Скрий филтри',
    creatingInvoices: 'Създаване на фактури, моля изчакайте...',
    bulkCreateInvoices: 'Масово създаване на фактури',
    cannotCreateAutopilot: 'Не можете да създавате фактури ръчно, когато режимът на фактуриране е на автопилот.',
    exportInvoices: 'Експортиране на фактури или поръчки',
    capturePayments: 'Ръчно събиране на плащания',
    filterOrders: 'Филтриране на поръчки',
    error: 'Нещо се обърка...',
    close: 'Затвори',
    chooseDate: 'Изберете дата',
    chooseIssueDate: 'Изберете дата на издаване за избраните фактури',
    cancel: 'Отказ',
    createInvoices: 'Създаване на фактури',
    storno: 'Сторно',
    bulkOrderCapture: 'Масово събиране на поръчки',
  },
  search: {
    createdBetween: 'Създадени м/у',
    modifiedBetween: 'Променени м/у',
    orderNumber: 'Поръчка №',
    invoiceNumber: 'Фактура №',
    refundNumber: 'Възстановяване №',
    customer: 'Клиент',
    payment: 'Плащане',
    any: 'Всички',
    authorized: 'Оторизирано',
    pending: 'В очакване',
    paid: 'Платено',
    partiallyPaid: 'Частично платено',
    refunded: 'Възстановено',
    voided: 'Анулирано',
    partiallyRefunded: 'Частично възстановено',
    unpaid: 'Неплатено',
    fulfillment: 'Изпълнение',
    fulfilled: 'Изпратена',
    partial: 'Частична',
    unfulfilled: 'Неизпратена',
    loading: 'Зареждане на поръчки...',
    search: 'Търсене',
  },
  orderList: {
    noCustomer: 'Няма клиент',
    downloadOrder: 'Изтегляне на поръчка',
    deleteWarning: 'Важно! Това ще изтрие всички фактури и възстановявания, създадени след датата:',
    includingInvoice: 'включително избраната фактура №',
    pressOk: 'Натиснете OK за продължаване или Отказ за прекратяване.',
    cannotCreateAutopilot: 'Не можете да създавате фактури ръчно, когато режимът на фактуриране е на автопилот.',
    createInvoice: 'Създаване на фактура за тази поръчка',
    create: 'Създай',
    addCreditNote: 'Добавяне на кредитно известие',
    createStorno: 'Създаване на сторно фактура',
    refund: 'Възстановяване',
    downloadInvoice: 'Изтеглете тази фактура',
    download: 'Изтегляне',
    default: 'По подразбиране',
    downloadStorno: 'Изтеглете това сторно/кредитно известие',
    fulfillOrder: 'Изпълнение на поръчка',
    orderNum: 'Поръчка №',
    locPrefix: 'Префикс на локация',
    invoiceNum: 'Фактура №',
    refundNum: 'Възстановяване №',
    customerCol: 'Клиент',
    orderCreatedDate: 'Дата на създаване на поръчката',
    orderModifiedDate: 'Дата на промяна на поръчката',
    delivered: 'Доставено',
    paymentStatus: 'Статус на плащане',
    fulfillmentStatus: 'Статус на доставка',
    totalOutstanding: 'Общо дължима сума',
    originalPrice: 'Оригинална цена',
    noOrders: 'Вашият магазин няма поръчки за избрания статус.',
    cannotCreateNoOrders: 'Не можете да създавате фактури, когато няма поръчки.',
    createOrdersFirst: 'Моля, създайте поне една поръчка и опитайте отново.',
    createOrders: 'Създаване на поръчки',
    loadingOrders: 'Зареждане...',
    paidManual: 'Платено - Ръчно',
    paid: 'Платено',
    refunded: 'Възстановено',
    pending: 'В очакване',
    partiallyPaid: 'Частично платено',
    partiallyRefunded: 'Частично възстановено',
    fulfilled: 'Изпратена',
    unfulfilled: 'Неизпратена',
    deliveryPending: 'В очакване',
    deliverNow: 'Достави сега',
    deliveryPartial: 'Частична',
    notDelivered: 'Недоставено',
    deliverAgain: 'Достави отново',
    deliveryDetails: 'Детайли за доставка',
    deliveryFailed: 'Доставката неуспешна',
    sent: 'Изпратено',
    failed: 'Неуспешно',
    toLabel: 'До',
    folderLabel: 'Папка',
    open: 'Отвори',
    invoice: 'Фактура',
    creditNote: 'Кредитно известие',
    stornoLabel: 'Сторно',
    unknown: 'Неизвестно',
    googleDrive: 'Google Drive',
    clientsTablet: 'Таблет за клиенти',
    shippyPro: 'ShippyPro',
    emailChannel: 'Имейл',
    ftpChannel: 'FTP',
    revertToDate: 'Върни към тази дата',
    add: 'Добави',
    close: 'Затвори',
  },
  downloadDialog: {
    downloadType: 'Изтегляне на {type}...',
    selectTemplate: 'Изберете шаблон от галерията за експортиране на поръчки, фактури, сторно фактури или кредитни известия.',
    getMoreTemplates: 'Вземете повече шаблони',
    createNewTemplate: 'Създайте нов шаблон',
    allCreatedBetween: 'Всички създадени {type} между',
    selectedType: 'Избрани {type}',
    and: 'и',
    status: 'Статус',
    any: 'Всички',
    open: 'Отворени',
    closed: 'Затворени',
    cancelled: 'Отменени',
    paymentStatus: 'Статус на плащане',
    fulfillmentStatus: 'Статус на доставка',
    fulfilled: 'Изпратена',
    partial: 'Частична',
    unfulfilled: 'Неизпратена',
    authorized: 'Оторизирано',
    pending: 'В очакване',
    paid: 'Платено',
    partiallyPaid: 'Частично платено',
    refunded: 'Възстановено',
    voided: 'Анулирано',
    partiallyRefunded: 'Частично възстановено',
    unpaid: 'Неплатено',
    format: 'Формат',
    forLocation: 'За локация',
    advancedOptions: 'Разширени опции',
    exportHSCodes: 'Експорт на HS кодове от инвентара (по-бавно)',
    noteChrome: 'Забележка: За оптимално изтегляне се препоръчва Chrome и деактивиране на блокер за реклами.',
    downloadIndividually: 'Изтегляне поединично',
    downloadGrouped: 'Изтегляне групирано',
  },
  templates: {
    pageTitle: 'Шаблони',
    pageDescription: 'Customize your invoice templates',
    title: 'Шаблони',
    installTranslated: 'Инсталирайте преведен шаблон',
    installTranslatedDesc: 'Изберете друг език, като щракнете върху този бутон.',
    createNew: 'Създайте нов шаблон, ако е необходимо',
    createNewDesc: 'Щракнете върху този бутон, за да създадете нов шаблон, ако е необходимо.',
    customize: 'Персонализиране на шаблони',
    customizeDesc: 'Щракнете върху шаблона по подразбиране, за да го персонализирате. Можете да промените логото, цветовете и за по-напреднали потребители - кода отзад.',
    defaultTemplate: 'Фактура, сторно и кредитно известие (по подразбиране)',
    logo: 'Лого',
    colorPalette: 'Цветова палитра',
    getColorPalettes: 'Вземете цветови палитри',
    paperSize: 'Размер на хартията',
    format: 'Формат',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Ориентация',
    landscape: 'Пейзаж',
    portrait: 'Портрет',
    margin: 'Поле (cm)',
    unsavedChanges: 'Незапазени промени',
    discard: 'Отхвърли',
    save: 'Запази',
  },
  labels: {
    pageTitle: 'Етикети за доставка',
    pageDescription: 'Create and manage shipping labels',
    title: 'Етикети за доставка',
    glsRequiresPro: 'GLS етикети за доставка за ИИЕ изискват план Professional.',
    upgradeDesc: 'Надградете до Professional, за да създавате и управлявате етикети за доставка.',
    upgradePlan: 'Надградете плана си',
    eeuGls: 'ИИЕ GLS',
    enabled: 'Активирано',
    country: 'Държава',
    hungary: 'Унгария',
    slovakia: 'Словакия',
    czech: 'Чехия',
    romania: 'Румъния',
    slovenia: 'Словения',
    croatia: 'Хърватия',
    senderId: 'ID на подател',
    username: 'Потребителско име',
    password: 'Парола',
    name: 'Име',
    city: 'Град',
    address: 'Адрес',
    zipCode: 'Пощенски код',
    contactPerson: 'Лице за контакт',
    phone: 'Телефон',
    email: 'Имейл',
    glsServices: 'GLS услуги',
    expressService: 'Експресна услуга',
    exchangeService: 'Услуга за обмен',
    smsService: 'SMS услуга',
    smsText: 'SMS текст',
    preAdviceService: 'Услуга за предварително уведомяване',
    unsavedChanges: 'Незапазени промени',
    discard: 'Отхвърли',
    save: 'Запази',
  },
  billing: {
    pageTitle: 'Фактуриране',
    pageDescription: 'Manage your subscription and billing',
    title: 'Фактуриране',
    subscriptionFor: 'Абонаментен план за магазин',
    currentlySubscribed: 'В момента сте абонирани за',
    plan: 'план',
    cancelSubscription: 'Отмяна на абонамент',
    upgradePlan: 'Надградете плана си',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / месец',
    upgrade: 'Надграждане',
    includesAllStarter: 'Включва всички функции на Starter, плюс:',
    proFeature1: 'Глобален пакет за съответствие: Префикси по локация и персонализирана последователна номерация',
    proFeature2: 'Интелигентна локализация: Автоматично преведени имейли и локализирани PDF прикачени файлове',
    proFeature3: 'Пълен B2B документооборот: Проформи, B2B оферти и кредитни известия',
    proFeature4: 'B2B счетоводна синхронизация: 3-десетична точност на единица и мултивалутно показване',
    proFeature5: 'Автоматични резервни копия: Автоматично копиране на фактури към защитен FTP или Google Drive',
    proFeature6: 'Shopify Flow: Автоматизирайте генерирането, доставката и сторнирането на фактури чрез Flow тригери и действия',
    proFeature7: 'Разширена AI логика: Използвайте вградения AI за сложни условни клаузи в оформлението',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X експорти (европейско съответствие за е-фактуриране)',
    proFeature9: 'EPC QR кодове за моментални мобилни POS плащания',
    proFeature10: 'GLS етикети за доставка за ИИЕ',
    proFeature11: '7-годишно съхранение за данъчно съответствие',
    currentlyUsing: 'В момента използвате нашия',
    free: 'безплатен',
    subscriptionPlan: 'абонаментен план.',
    monthlyUsage: 'Месечна употреба',
    monthlyGenerated: '{count} / 50 фактури този месец',
    monthlyLimitReached: 'Месечният лимит е достигнат. Надградете до Starter за неограничени фактури.',
    freePlan: 'Безплатен план',
    freeToInstall: 'Безплатна инсталация',
    freeFeature1: 'До 50 фактури/поръчки на месец',
    freeFeature2: 'Достъп до всички 31+ предварително дефинирани шаблони',
    freeFeature3: 'Основен AI Copilot',
    freeFeature4: 'Стандартно изтегляне и печат на PDF',
    freeFeature5: 'Стандартен набор от документи (Фактури, Опаковъчни листове, Разписки)',
    freeFeature6: '3-месечно сигурно съхранение на фактури',
    starterPlan: 'Стартов план',
    starterPrice: '$9.99 / месец',
    starterPricePerInvoice: '+ 3¢ за всяка създадена фактура',
    subscribe: 'Абониране',
    starterFeature1: 'Неограничени фактури и поръчки',
    starterFeature2: 'Автоматична доставка на PDF по имейл',
    starterFeature3: 'Пълен достъп до хибриден редактор и AI Copilot',
    starterFeature4: 'Shopify POS и интеграция с баркод',
    starterFeature5: 'Shopify Flow: Тригери и действия за автоматизация на фактури',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X експорти (съответствие за е-фактуриране)',
    starterFeature7: '1-годишно сигурно съхранение на фактури',
    proTaxOverrides: 'Персонализирани данъчни замествания: ДДС / GST по продукт и ставки по SKU',
    unsavedChanges: 'Незапазени промени',
    discard: 'Отхвърли',
    save: 'Запази',
  },
  autopilot: {
    pageTitle: 'Автоматизация',
    pageDescription: 'Automate invoice creation and management',
    title: 'Автоматизация',
    autoCreate: 'Автоматично създаване на фактури',
    disabled: 'Деактивирано (Ръчно)',
    whenCreated: 'Когато поръчките са създадени',
    whenFulfilled: 'Когато поръчките са изпълнени',
    whenPaid: 'Когато поръчките са платени',
    autoCreateDesc: 'Фактурите ще бъдат създадени на датата, когато поръчките са създадени, изпълнени или платени.',
    autoStorno: 'Автоматично сторниране на фактури',
    whenCancelled: 'Когато поръчките са отменени или възстановени',
    autoStornoDesc: 'Сторно фактури ще бъдат създадени на датата, когато поръчките са анулирани/отменени или са създадени възстановявания.',
    cannotAutoFree: 'Автоматичното създаване на фактури не може да се извършва с безплатния план.',
    upgradePlan: 'Надградете плана си',
    unsavedChanges: 'Незапазени промени',
    discard: 'Отхвърли',
    save: 'Запази',
  },
  delivery: {
    pageTitle: 'Доставка',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Доставка',
    settings: 'Настройки',
    useOrderNumbers: 'Използване на номера на поръчки за файлове',
    sendIfCountry: 'Изпращане, ако държавата на адреса за фактуриране е',
    countryCodesHint: 'Изброете всички кодове на държави, разделени с точка и запетая.',
    sendForTags: 'Изпращане за клиенти, които имат един от изброените тагове',
    tagsHint: 'Изброете всички тагове, разделени с точка и запетая.',
    emailDelivery: 'Доставка по имейл',
    sendAsPdf: 'Изпращане на фактури като PDF прикачени файлове на клиенти',
    autoSend: 'Автоматично изпращане при създаване на фактура',
    subject: 'Тема',
    body: 'Съдържание',
    xmlAttachments: 'XML прикачени файлове',
    attachUbl: 'Прикачване на UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Прикачване на ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Изпращане на тестов имейл',
    sending: 'Изпращане...',
    customSmtp: 'Персонализиран SMTP сървър',
    customSmtpDesc: 'Използвайте собствен пощенски сървър вместо стандартния',
    enableSmtp: 'Активиране на персонализиран SMTP',
    smtpHost: 'SMTP хост',
    port: 'Порт',
    useSsl: 'Използване на SSL/TLS',
    username: 'Потребителско име',
    password: 'Парола',
    fromEmail: 'Имейл на подателя',
    fromName: 'Име на подателя',
    shopifyLiquid: 'Shopify Liquid шаблон',
    pasteInto: 'Поставете това във вашия',
    orderConfirmation: 'шаблон за потвърждение на поръчка',
    toAddLink: 'за да добавите линк за изтегляне.',
    downloadInvoice: 'Изтеглете вашата фактура',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Изпращане на заявки към ClientsTablet при създаване на фактури',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Изпращане на PDF фактури като митнически документи към ShippyPro за държави извън ЕС',
    ftpBackup: 'FTP / SFTP резервно копие',
    ftpDesc: 'Автоматично копиране на фактури на вашия сървър',
    enableFtp: 'Активиране на автоматично FTP резервно копие',
    host: 'Хост',
    useSftp: 'Използване на SFTP (защитен)',
    destinationFolder: 'Целева папка',
    xmlFiles: 'XML файлове',
    includeUbl: 'Включване на UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Включване на ZUGFeRD / Factur-X XML',
    testConnection: 'Тестване на връзката',
    testing: 'Тестване...',
    pro: 'PRO',
    upgradeFtp: 'Надградете до Professional за автоматично копиране на фактури на вашия FTP/SFTP сървър.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Автоматично синхронизиране на фактури с вашия Drive',
    connected: 'Свързано',
    disconnect: 'Прекъсване',
    notWorking: 'Не работи? Отидете на',
    googlePermissions: 'Google разрешения',
    removeThenReconnect: 'премахнете Invoice Browse, след което се свържете отново.',
    connectGoogleDrive: 'Свързване с Google Drive',
    upgradeGoogleDrive: 'Надградете до Professional за автоматично синхронизиране на фактури с Google Drive.',
    unsavedChanges: 'Незапазени промени',
    discard: 'Отхвърли',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Запази',
  },
  bookkeeping: {
    pageTitle: 'Настройки',
    pageDescription: 'Configure your invoice settings',
    title: 'Настройки',
    owner: 'Собственик',
    email: 'Имейл',
    phone: 'Телефон',
    keepDifferentNumbering: 'Поддържане на различна номерация на фактури за всяка локация на поръчката',
    keepDifferentNumberingDisabled: 'Поддържането на различна номерация на фактури за всяка локация на поръчката не е опция, активирана с вашия план.',
    locationEmailDesc: 'Това ви позволява да изпращате имейли и фактури, преведени на базата на локацията на поръчката: складова локация, адрес за доставка или адрес за фактуриране',
    upgradePlan: 'Надградете плана си',
    matchingCriteria: 'Критерии за съвпадение',
    locationId: 'ID на локация',
    shippingCountryCode: 'Код на държава на адрес за доставка',
    billingCountryCode: 'Код на държава на адрес за фактуриране',
    matchLocationDesc: 'Съвпадение на локация на базата на ID на локацията на поръчката, код на държава на адрес за доставка или фактуриране.',
    companyInfo: 'Информация за компанията',
    name: 'Име',
    website: 'Уебсайт',
    registrationNumber: 'Регистрационен номер',
    taxId: 'Данъчен номер',
    addressSection: 'Адрес',
    streetName: 'Улица',
    streetNumber: 'Номер',
    zip: 'Пощенски код',
    city: 'Град',
    region: 'Регион',
    country: 'Държава',
    bankingInfo: 'Банкова информация',
    bankName: 'Име на банка',
    swift: 'Swift',
    currency: 'Валута',
    iban: 'IBAN',
    invoicing: 'Фактуриране',
    decimalPlaces: 'Десетични знаци',
    invoicesPrefix: 'Префикс на фактури',
    currentInvoiceNumber: 'Текущ номер на фактура',
    creditNotesPrefix: 'Префикс на кредитни известия',
    currentCreditNoteNumber: 'Текущ номер на кредитно известие',
    lastInvoiceDate: 'Дата на последна фактура',
    noInvoicesYet: 'Все още няма създадени фактури.',
    confirmReverting: 'Потвърждаване на връщане на системата',
    allInvoicesAfter: 'Всички фактури и техните сторна, издадени след',
    willBeRemoved: 'ще бъдат премахнати. Продължаване с връщане на системата?',
    cancel: 'Отказ',
    revert: 'Връщане',
    revertDesc: 'Връщането на системата ще изтрие всички фактури, създадени след избраната дата.',
    revertToDate: 'Връщане до тази дата',
    reverting: 'Връщане на системата, моля изчакайте...',
    useOrderNumbering: 'Използване на номерация на поръчки',
    showVat: 'Показване на ДДС във фактурите',
    overrideTaxes: 'Замяна на данъци',
    pricesIncludeTax: 'Цените включват данък',
    productsTaxRate: 'Данъчна ставка за продукти',
    shippingTaxRate: 'Данъчна ставка за доставка',
    skusSeparated: 'SKU-та, разделени с точка и запетая',
    skusTaxRate: 'Данъчна ставка за SKU-та',
    useOrderDates: 'Използване на дати на създаване на поръчки за фактури',
    convertCurrency: 'Конвертиране на цени във валутата, в която клиентът плаща',
    unsavedChanges: 'Незапазени промени',
    discard: 'Отхвърли',
    save: 'Запази',
  },
  drafts: {
    pageTitle: 'Чернови',
    pageDescription: 'Manage your draft orders',
    title: 'Чернови',
    download: 'Изтегляне',
    newDraft: 'Нова чернова',
    exporting: 'Експортиране {status}%...',
    accessNotGranted: 'Достъпът до чернови поръчки не е предоставен. Моля',
    reLogin: 'влезте отново',
    toGrantPermissions: 'за да предоставите необходимите разрешения за "Чернови поръчки".',
    pushFailed: 'Изпращането към Shopify неуспешно:',
    exportError: 'Грешка при експортиране:',
    confirmDelete: 'Сигурни ли сте, че искате да изтриете тази чернова?',
    incompleteCustomer: 'Данните за клиента са непълни:',
    pushWithoutCustomer: 'Черновата ще бъде изпратена към Shopify без данни за клиента. Продължаване?',
    customerNotInShopify: 'Този клиент все още не съществува в Shopify.',
    warnings: 'Предупреждения:',
    createCustomerAndPush: 'Създаване на клиента в Shopify и изпращане на черновата поръчка?',
    downloadTitle: 'Изтегли чернови',
    cancel: 'Отказ',
  },
  draftEdit: {
    number: "Номер",
    prefix: "Префикс",

    newDraft: 'Нова чернова',
    editDraft: 'Редактиране на чернова',
    viewInShopify: 'Преглед в Shopify',
    back: 'Назад',
    createDraft: 'Създаване на чернова',
    saveChanges: 'Запазване на промените',
    documentType: 'Тип документ',
    draftOrder: 'Чернова поръчка',
    quote: 'Оферта',
    proforma: 'Проформа',
    manualInvoice: 'Ръчна фактура',
    currency: 'Валута',
    expiryDate: 'Дата на изтичане',
    status: 'Статус',
    draft: 'Чернова',
    sent: 'Изпратено',
    accepted: 'Прието',
    customer: 'Клиент',
    firstName: 'Име',
    lastName: 'Фамилия',
    email: 'Имейл',
    phone: 'Телефон',
    company: 'Компания',
    taxId: 'Данъчен номер',
    billingAddress: 'Адрес за фактуриране',
    address: 'Адрес',
    aptSuite: 'Апартамент/Офис',
    city: 'Град',
    province: 'Област',
    countryField: 'Държава',
    zip: 'Пощенски код',
    shippingAddress: 'Адрес за доставка',
    sameAsBilling: 'Същият като за фактуриране',
    lineItems: 'Редове',
    shipping: 'Доставка',
    shippingTitle: 'Заглавие',
    shippingPlaceholder: 'напр. Стандартна доставка',
    price: 'Цена',
    note: 'Бележка',
    notePlaceholder: 'Вътрешна бележка или съобщение до клиента...',
    summary: 'Обобщение',
    subtotal: 'Междинна сума',
    discounts: 'Отстъпки',
    tax: 'Данък',
    total: 'Общо',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Въведете адреса на вашия магазин',
    loginWith: 'Вход с',
    createAccount: 'Създаване на нов акаунт',
    placeholder: 'име-на-вашия-магазин',
    shopRequired: 'Името на магазина е задължително',
    login: 'Вход',
    shopify: 'Shopify',
    terms: 'Общи условия',
    privacy: 'Политика за поверителност',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Харесва ли ви Invoice Browse?',
    description: 'Създадохте първите си фактури! Ако намирате приложението за полезно, бърз отзив в Shopify App Store ни помага много.',
    reward: 'Като благодарност ще нулираме брояча на месечната ви употреба до 0',
    leaveReview: 'Оставете отзив',
    maybeLater: 'Може би по-късно',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Добре дошли в Invoice Browse',
    welcomeContent: 'Позволете ми да ви покажа как можете да го използвате.',
    dashboardTitle: 'Табло',
    dashboardContent: 'Екранът, който виждате, е главното табло. Тук можете да намерите всички поръчки и да ги експортирате в различни типове документи като: фактури, опаковъчни листове и други.',
    automationTitle: 'Улеснете живота си',
    automationContent: 'Активирайте автоматизацията, за да създавате фактури при плащане или възстановяване на поръчки.',
    templatesTitle: 'Персонализиране на шаблони',
    templatesContent: 'Влезте тук, за да преведете шаблона си, да го персонализирате или да създадете нов.',
    deliveryTitle: 'Доставка',
    deliveryContent: 'Конфигурирайте нашето приложение автоматично да копира създадени документи на FTP, Google Drive или като прикачени файлове за имейли.',
    settingsTitle: 'Настройки',
    settingsContent1: 'Настройте телефон, имейл и други полета на компанията, използвани в документите.',
    settingsContent2: 'Променете началния номер на документа или изтрийте документи, създадени след определена дата.',
    settingsContent3: 'Заменете ДДС ставките за доставка и продукти',
    settingsContent4: 'Променете десетичните знаци за числата',
    reviewTitle: 'Напишете отзив',
    reviewContent: 'Подкрепете нашия екип, като ни напишете добър отзив!',
    tourTitle: 'Обиколка за добре дошли',
    tourContent: 'Можете да отворите тази обиколка отново от тук.',
    createDocTitle: 'Създайте първия си документ',
    createDocContent: 'Щракнете върху бутона Създай, за да създадете първия си документ.',
    docNumberTitle: 'Номер на документ',
    docNumberContent: 'Първият документ има зададен номер 1. Ако искате да започнете с друг номер, можете да го промените от Настройки.',
    downloadDocTitle: 'Изтегляне на документ',
    downloadDocContent: 'Щракнете върху падащото меню Изтегляне и изберете шаблон за документ, за да експортирате поръчката си като PDF.',
  },
  common: {
    save: 'Запази',
    cancel: 'Отказ',
    close: 'Затвори',
    discard: 'Отхвърли',
    delete: 'Изтриване',
    edit: 'Редактиране',
    create: 'Създаване',
    loading: 'Зареждане...',
    unsavedChanges: 'Незапазени промени',
    upgradePlan: 'Надградете плана си',
  },
  languageSelector: {
    label: 'Език',
    auto: 'Автоматично разпознаване',
  },
  draftList: {
    draftNum: 'Чернова #',
    shopifyId: 'Shopify ID',
    type: 'Тип',
    customer: 'Клиент',
    total: 'Общо',
    status: 'Статус',
    delivered: 'Доставено',
    date: 'Дата',
    actions: 'Действия',
    noCustomer: 'Няма клиент',
    noDrafts: 'Няма намерени чернови или оферти.',
    loading: 'Зареждане...',
    download: 'Изтегляне',
    default: 'По подразбиране',
    pending: 'Изчакване',
    deliverNow: 'Достави сега',
    deliveryDetails: 'Детайли за доставка',
    sent: 'Изпратено',
    failed: 'Неуспешно',
    deliverAgain: 'Достави отново',
    partial: 'Частично',
    notDelivered: 'Недоставено',
    deliveryFailed: 'Доставката е неуспешна',
    unknown: 'Неизвестно',
    edit: 'Редактиране',
    send: 'Изпращане',
    pushToShopify: 'Изпрати към Shopify',
    complete: 'Завърши',
    duplicate: 'Дублиране',
    delete: 'Изтриване',
    quote: 'Оферта',
    proforma: 'Проформа',
    draftOrder: 'Чернова на поръчка',
    manualInvoice: 'Ръчна фактура',
  },
  draftSearch: {
    createdBtw: 'Създадена м/у',
    draftNum: 'Чернова #',
    shopifyId: 'Shopify ID',
    customer: 'Клиент',
    status: 'Статус',
    type: 'Тип',
    delivery: 'Доставка',
    any: 'Всички',
    draft: 'Чернова',
    sent: 'Изпратено',
    accepted: 'Прието',
    expired: 'Изтекло',
    converted: 'Конвертирано',
    cancelled: 'Отменено',
    quote: 'Оферта',
    proforma: 'Проформа',
    draftOrder: 'Чернова на поръчка',
    manualInvoice: 'Ръчна фактура',
    delivered: 'Доставено',
    notDelivered: 'Недоставено',
    pending: 'Изчакване',
    search: 'Търсене',
  },
  draftDownload: {
    title: 'Изтегляне на чернови и оферти...',
    selectTemplate: 'Изберете шаблон от галерията, за да експортирате чернови, оферти или проформи.',
    allDraftsBetween: 'Всички чернови между',
    selectedDrafts: 'Избрани чернови',
    and: 'и',
    status: 'Статус',
    documentType: 'Тип документ',
    any: 'Всички',
    draft: 'Чернова',
    sent: 'Изпратено',
    accepted: 'Прието',
    expired: 'Изтекло',
    converted: 'Конвертирано',
    cancelled: 'Отменено',
    quote: 'Оферта',
    proforma: 'Проформа',
    draftOrder: 'Чернова на поръчка',
    manualInvoice: 'Ръчна фактура',
    format: 'Формат',
    noTemplates: 'Няма намерени шаблони',
    noTemplatesForType: 'Няма намерени шаблони за тип документ „{type}".',
    installTemplates: 'Инсталиране на шаблони',
    toStartExporting: 'за да започнете експортирането.',
    noteChrome: 'Забележка: За оптимално изтегляне се препоръчва Chrome и деактивиране на рекламни блокери.',
    cancel: 'Отказ',
    downloadIndividually: 'Изтегляне поединично',
    downloadGrouped: 'Изтегляне групирано',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Инсталиране на нов шаблон',
    tabStyle: 'Стил',
    tabContent: 'Съдържание',
    tabTranslations: 'Преводи',
    tabSettings: 'Настройки',
    tabCode: 'Код',
    tabCopilot: 'AI Копилот',
    logo: 'Лого',
    colorPalette: 'Цветова палитра',
    colorText: 'Текст',
    colorBg: 'Фон',
    colorBorder: 'Рамка',
    colorPrimary: 'Основен',
    colorAccent: 'Акцент',
    font: 'Шрифт',
    fontDefault: 'По подразбиране (DM Sans)',
    fontSize: 'Размер на шрифта',
    fontSizeDefault: 'По подразбиране (11.5px)',
    fontSizeCompact: 'Компактен',
    fontSizeSmall: 'Малък',
    fontSizeMediumSmall: 'Средно-малък',
    fontSizeMedium: 'Среден',
    fontSizeMediumLarge: 'Средно-голям',
    fontSizeLarge: 'Голям',
    fontSizeExtraLarge: 'Много голям',
    documentTitle: 'Заглавие на документа',
    documentTitlePlaceholder: 'напр. Фактура, Данъчна фактура...',
    noToggleSupport: 'Този шаблон не поддържа превключващи контроли. Превключете към шаблон от галерията за пълна персонализация.',
    sections: 'Секции',
    shippingAddress: 'Адрес за доставка',
    bankPaymentDetails: 'Банкови/платежни данни',
    paymentStatusBadge: 'Бадж за статус на плащане',
    orderNotes: 'Бележки към поръчката',
    trackingFulfillment: 'Проследяване/изпълнение',
    termsConditions: 'Общи условия',
    signatureLines: 'Редове за подпис',
    qrCode: 'QR код',
    lineItems: 'Артикули',
    taxColumns: 'Колони за данъци (ДДС)',
    productSku: 'SKU на продукта',
    productImages: 'Изображения на продукта',
    discountBreakdown: 'Разбивка на отстъпки',
    itemWeight: 'Тегло на артикула',
    hsCode: 'HS код (митници)',
    mergeDiscounts: 'Обединяване на отстъпки в цената на продукта',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Общи суми',
    subtotalBeforeTax: 'Междинна сума (преди данъци)',
    taxBreakdownByRate: 'Разбивка на данъци по ставка',
    shippingCostSeparate: 'Разходи за доставка като отделен ред',
    dueDate: 'Срок за плащане',
    formatting: 'Форматиране',
    dateFormat: 'Формат на датата',
    decimalPlaces: 'Десетични знаци',
    paymentTerms: 'Условия за плащане',
    paymentTermsNone: 'Няма',
    thankYouMessage: 'Благодарствено съобщение',
    thankYouPlaceholder: 'Благодарим ви за покупката!',
    countryMatchTitle: 'Използвай този шаблон, когато адресът за доставка или фактуриране съвпада с тази държава',
    addressType: 'Тип адрес',
    addressDisabled: 'Деактивирано',
    addressShipping: 'Адрес за доставка',
    addressBilling: 'Адрес за фактуриране',
    country: 'Държава',
    anyCountry: 'Всяка държава',
    countryMatchDesc: 'Когато е активирано, този шаблон ще се използва автоматично за поръчки, при които избраният адрес съвпада с избраната държава.',
    languagePreset: 'Езикова настройка',
    selectLanguage: 'Изберете език...',
    languagePresetDesc: 'Избирането на език попълва всички етикети по-долу. След това можете да персонализирате отделни полета.',
    paperSize: 'Размер на хартията',
    format: 'Формат',
    orientation: 'Ориентация',
    portrait: 'Портрет',
    landscape: 'Пейзаж',
    margin: 'Поле (cm)',
    template: 'Шаблон',
    templateName: 'Име',
    systemAlias: 'Системен псевдоним',
    systemAliasDesc: 'за POS/Admin URL маршрути',
    systemAliasNone: 'Няма',
    defaultTemplate: 'Шаблон по подразбиране',
    defaultTemplateDesc: 'Използва се за директни връзки, споделени с клиенти.',
    posRouteDesc: 'Съответства на /template/[alias]/receipt.pdf за POS интеграция.',
    documentType: 'Тип документ',
    invoiceCreditNote: 'Фактура + Кредитно известие',
    order: 'Поръчка',
    invoiceOnly: 'Само фактура',
    quoteEstimate: 'Оферта/Оценка',
    proformaInvoice: 'Проформа фактура',
    refund: 'Възстановяване',
    stornoInvoice: 'Сторно фактура',
    creditNoteOnly: 'Само кредитно известие',
    reportLiquid: 'Отчет (само Liquid)',
    hideRemovedItems: 'Скриване на премахнати/възстановени артикули',
    location: 'Локация',
    locationEmpty: 'Оставете празно за всички локации',
    dangerZone: 'Опасна зона',
    dangerZoneDesc: 'Окончателно премахване на този шаблон от акаунта ви.',
    removeTemplate: 'Премахване на шаблон',
    bodyTemplate: 'Основен шаблон',
    bodyTemplateDesc: 'Използва Mustache или Liquid синтаксис. Кликнете върху фрагмент:',
    rowTemplate: 'Шаблон за ред',
    rowTemplateDesc: 'Рендерира се веднъж за всеки артикул. Кликнете върху фрагмент:',
    variableReference: 'Справка за променливи',
    formatCode: 'Форматиране на код',
    insert: 'Вмъкване',
    copy: 'Копиране',
    loadModelContinue: 'Зареждане на модела и продължаване',
    cancel: 'Отказ',
    copilotPlaceholder: 'Опитайте: преведи на български, покажи колони за данъци, добави баркод...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Отмяна',
    redo: 'Повтори',
    aiThinking: 'AI мисли...',
    proposedChanges: 'Предложени промени',
    applyChanges: 'Приложи промените',
    dismiss: 'Отхвърли',
    aiEngineReady: 'AI двигател готов',
    loadingAiModel: 'Зареждане на AI модел...',
    aiEngineOff: 'AI двигател изключен —',
    loadForAdvanced: 'зареди за разширено редактиране',
    instantCommands: 'превод, показване/скриване на секции, добавяне на фрагменти, промяна на шрифт/цветове/хартия',
    aiEngineDesc: 'структурни HTML редакции, промени в оформлението, персонализирани модификации',
    aiLocalDesc: 'Моделът работи локално чрез WebGPU — никакви данни не напускат браузъра ви.',
    aiUpgradeDesc: 'надградете до Starter или Professional за разширено AI редактиране на шаблони.',
    upgrade: 'Надграждане',
    loadAiQuestion: 'Зареди AI двигател?',
    loadAiDesc: 'AI моделът ще бъде изтеглен и ще работи локално чрез WebGPU. Изисква ~1-3 GB свободна VRAM/RAM и модерен GPU.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/bg.js